import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UsdkFota = function (_NebulaModuleBase) {
    _inherits(UsdkFota, _NebulaModuleBase);

    function UsdkFota() {
        _classCallCheck(this, UsdkFota);

        return _possibleConstructorReturn(this, (UsdkFota.__proto__ || Object.getPrototypeOf(UsdkFota)).apply(this, arguments));
    }

    _createClass(UsdkFota, [{
        key: 'getFOTAAbility',
        value: function getFOTAAbility(params) {
            return this.generatePromiseByFunctionWithParams('getFOTAAbilityForUSDKPlugin', params);
        }
    }, {
        key: 'getFOTAStatus',
        value: function getFOTAStatus(params) {
            return this.generatePromiseByFunctionWithParams('getFOTAStatusForUSDKPlugin', params);
        }
    }, {
        key: 'startFOTA',
        value: function startFOTA(params) {
            return this.generatePromiseByFunctionWithParams('startFOTAForUSDKPlugin', params);
        }
    }, {
        key: 'setUSDKFOTAListener',
        value: function setUSDKFOTAListener(params, uSDKFOTAListener) {
            var event = 'onUpdateFOTAStatus' + params.deviceId;
            var param = {
                eventName: event,
                deviceId: params.deviceId
            };
            this.generatePromiseByAttachListenerWithParams(event, function (result) {
                uSDKFOTAListener(result);
            });
            return this.generatePromiseByFunctionWithParams('setUSDKFOTAListenerForUSDKPlugin', param);
        }
    }, {
        key: 'removeUSDKFOTAListener',
        value: function removeUSDKFOTAListener(params, uSDKFOTAListener) {
            var event = 'onUpdateFOTAStatus' + params.deviceId;
            var param = {
                eventName: event,
                deviceId: params.deviceId
            };
            return this.generatePromiseByDetachListenerWithParams(event, uSDKFOTAListener, 'removeUSDKFOTAListenerForUSDKPlugin', param);
        }
    }]);

    return UsdkFota;
}(NebulaModuleBase);